<arivo-alerts></arivo-alerts>

@if (showAccountBalance || openParkingSessions.length !== 0) {
  <div class="flex gap-4 flex-col xl:flex-row mb-8">
    @if (showAccountBalance) {
      <div class="flex-1">
        <app-dashboard-account-balance />
      </div>
    }
    @if (openParkingSessions.length !== 0) {
      <div class="flex-1">
        <app-dashboard-open-parking-sessions />
      </div>
    }
  </div>
}

<div class="flex flex-col gap-8" [ngClass]="{ 'flex-col': !hasContracts, 'flex-col-reverse': hasContracts }">
  @if (showPayPerUseDashboard) {
    <div>
      <app-dashboard-pay-per-use />
    </div>
  }

  
  @if (showContractRequests) {
    <div>
      <app-dashboard-contract-requests></app-dashboard-contract-requests>
    </div>
  }

  <div>
    <app-dashboard-contracts></app-dashboard-contracts>
  </div>
</div>
